import { render, staticRenderFns } from "./Topology.vue?vue&type=template&id=97116316"
import script from "./Topology.vue?vue&type=script&lang=ts"
export * from "./Topology.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports